import SignedByte from './Integers/SignedByte';
export default function asSignedByte(value) {
    return new SignedByte(value);
}
